<script>

    export let sendData;

    let jobs = ['Frontend Developer', 'Backend Developer', 'Full Stack Developer', 'Software Systems Engineer', ' Software Engineer', 'Backend Engineer']
    let checked_jobs = []

    let locations = ['Zug', 'Zurich', 'Geneva', 'Lausanne', 'Locarno', ' Lugano', 'Aargau'];
    let checked_locations = []

    let job_show_dropdown = false;
    let location_show_dropdown = false;

    let job_input_value = "";
    let location_input_value = "";

    let experience = ['Internship', 'Entry level', 'Associate', 'Director', 'Executive'];
    let checked_exp = [];

    let job_type = ['Full-Time', 'Part-Time', 'Contract', 'Temporary', 'Internship']
    let checked_job_type = [];

    let toggle_dropdown = (input) => {
        if (input === "job") {
            job_show_dropdown = !!job_input_value;
        }
        else {
            location_show_dropdown = !!location_input_value;
        }

    }
    let addJobs = (item, input) => {
        console.log("in addJobs")
        if (input === "job") {
            console.log("in if")
            checked_jobs.push(item);
            checked_jobs = checked_jobs;
            console.log(checked_jobs)
            job_input_value = "";
            job_show_dropdown = false;
        }
        else  {
            checked_locations.push(item);
            checked_locations = checked_locations;
            location_input_value = "";
            location_show_dropdown = false;
        }

    }
    let deleteSkill = (i, input="none") => {
        if (input === "job") {
            checked_jobs.splice(i, 1);
            checked_jobs = checked_jobs;
        }
        else {
            checked_locations.splice(i, 1);
            checked_locations = checked_locations;
        }

    }

    let prepData = () => {
        let data = {
            'jobs' : checked_jobs,
            'locations' : checked_locations,
            'experience' : checked_exp,
            'job-type' : checked_job_type
        };
        sendData(data);
    }


    
    
    
</script>

<div class="filter_container">
    
    <div class="filter_wrapper">

        <div class="content_container">

            <div class="inputs">
                <img src="assets/svgs/jobs.svg" alt="">

                <div class="input_container">

                    <input type="text" bind:value={job_input_value} on:input={() => toggle_dropdown("job")} placeholder="Job">

                </div>

                {#if job_show_dropdown}

                    <div class="dropdown_container">

                        {#each jobs as job}
                            <span class="dropdown_cell" on:click={() => {addJobs(job, "job")}}>{job}</span>
                        {/each}

                    </div>

                {/if}

            </div>

            {#if checked_jobs.length > 0}

                <div class="cell_container">
                    <div class="cell">

                        {#each checked_jobs as cjob, i}

                            <span class="cell_content" on:click={() => deleteSkill(i, "job")}>{cjob}</span>

                        {/each}
                    </div>

                </div>

            {/if}

        </div>
        
        <div class="content_container">

            <div class="inputs">
                <img src="assets/svgs/location.svg" alt="">

                <div class="input_container">

                    <input type="text" bind:value={location_input_value} on:input={() => toggle_dropdown("none")} placeholder="Location">

                </div>

                {#if location_show_dropdown}

                    <div class="dropdown_container">

                        {#each locations as loc}
                            <span class="dropdown_cell" on:click={() => {addJobs(loc, "none")}}>{loc}</span>
                        {/each}

                    </div>

                {/if}

            </div>

            {#if checked_locations.length > 0}

                <div class="cell_container">
                    <div class="cell">

                        {#each checked_locations as cloc, i}

                            <span class="cell_content" on:click={() => deleteSkill(i)}>{cloc}</span>

                        {/each}
                    </div>

                </div>

            {/if}

        </div>



        <div class="typ_lvl_container">

            <span class="title">Experience Level</span>

            {#each experience as exp}
                <div class="lvl_inputs">
                    <input type="checkbox" bind:group={checked_exp} value="{exp}"/>
                    <span>{exp}</span>
                </div>
            {/each}
        </div>

        <div class="typ_lvl_container">
            <span class="title">Job Type</span>

            {#each job_type as type}
                <div class="lvl_inputs">
                    <input type="checkbox" bind:group={checked_job_type} value="{type}"/>
                    <span>{type}</span>
                </div>
            {/each}

        </div>

        <div class="arrow">
            <span>Let's do it!</span>
            <img on:click={prepData} src="assets/svgs/right-arrow.svg" alt="">
        </div>

    </div>

</div>

<style>
    .filter_container {
        display: flex;
        justify-content: center;
        padding-top: 5vw;
        width: 100%;
    }
    .filter_wrapper {
        width: 90%;
    }
    .content_container {
        margin-bottom: 5vw;
    }
    .inputs {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 95%;
        position: relative;

    }
    .inputs img {
        height: 6vw;
        width: 6vw;
        margin-right: 4vw;

    }
    .input_container {
        margin-bottom: unset;
        width: 100%;
        z-index: 2;

    }
    .input_container input {
        padding-left: 0;
        background-color: transparent;
    }
    .dropdown_container {
        position: absolute;
        width: 90%;
        display: flex;
        flex-direction: column;
        background-color: white;
        top: 100%;
        padding-left: 9vw;
        z-index: 10;

    }
    .dropdown_container .dropdown_cell {
        padding: 4vw 0 4vw 0;
        border: none;
        border-bottom: 1px solid rgba(0,0,0,0.3);
        z-index: 10;

    }
    .cell_container {
        width: 95%;
        margin-top: 1.5vw;
    }
    .cell {
        padding-left: 10vw;
        display: flex;
        flex-wrap: wrap;

    }
    .cell_container .cell .cell_content {
        border: 1px solid black;
        border-radius: 4px;
        padding: 0 2vw;
        margin: 0 2vw 1.5vw 0;
        font-size: 3vw;
        width: max-content;
    }
    .typ_lvl_container {
        margin-bottom: 4vw;

    }
    .title {
        font-weight: 600;
        line-height: 10vw;
    }
    .lvl_inputs {
        display: flex;
        margin-bottom: 2vw;


    }
    .lvl_inputs span {
        margin-left: 4vw;

    }
    .lvl_inputs input {

    }
    .arrow {
        display: flex;
        width: 90%;
        justify-content: flex-end;
        margin-top: 4vw;
        align-items: center;
    }
    .arrow img {
        width: 10vw;
        margin-left: 2vw;
    }


</style>